module.exports = __webpack_public_path__ + "static/media/img2-3.691fd675.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/nogal/nutricheck_foliar/P/img2-3.png
// module id = 1953
// module chunks = 3